// Telegram присылает названия реакций только на английском, поэтому поиск по
// ним не работает для русскоязычного оператора. Здесь слова для поиска на обоих
// языках. Ключ - эмодзи без селектора варианта U+FE0F.
export const REACTION_KEYWORDS: Record<string, string> = {
    '❤': 'сердце красное любовь любит heart love',
    '👍': 'палец вверх лайк класс нравится да like thumbs',
    '👎': 'палец вниз дизлайк плохо нет dislike',
    '🔥': 'огонь пожар жар круто fire hot',
    '🥰': 'умиление сердечки влюблён милота love',
    '👏': 'аплодисменты хлопки браво молодец clap',
    '😁': 'улыбка радость смех smile',
    '🤔': 'думаю задумался мысль вопрос think',
    '🤯': 'взрыв мозга шок офигеть mind blown',
    '😱': 'крик ужас страх шок scream',
    '🤬': 'ругань мат злость гнев angry',
    '😢': 'слеза грусть плачу печаль sad cry',
    '🎉': 'праздник хлопушка поздравляю ура party',
    '🤩': 'восторг звёзды звезды вау wow star',
    '🤮': 'тошнит рвота фу мерзость vomit',
    '💩': 'какашка говно фу poo',
    '🙏': 'руки молитва спасибо пожалуйста прошу pray thanks',
    '👌': 'окей ок хорошо отлично okay ok',
    '🕊': 'голубь мир птица dove peace',
    '🤡': 'клоун clown',
    '🥱': 'зевота скучно сон зеваю yawn bored',
    '🥴': 'пьяный опьянение помутнение woozy drunk',
    '😍': 'влюблён глаза сердечки восторг love eyes',
    '🐳': 'кит whale',
    '❤\u200d🔥': 'сердце в огне страсть heart fire',
    '🌚': 'луна тёмный темный намёк moon',
    '🌭': 'хот-дог хотдог сосиска еда hotdog',
    '💯': 'сто процентов точно стопудово hundred',
    '🤣': 'смех ржу угар хохот lol laughing',
    '⚡': 'молния ток энергия lightning',
    '🍌': 'банан banana',
    '🏆': 'кубок победа приз награда trophy win',
    '💔': 'разбитое сердце разрыв broken heart',
    '🤨': 'бровь сомнение недоверие подозрение eyebrow',
    '😐': 'нейтрально без эмоций равнодушие neutral',
    '🍓': 'клубника ягода strawberry',
    '🍾': 'шампанское бутылка праздник champagne',
    '💋': 'поцелуй губы помада kiss',
    '🖕': 'средний палец фак finger',
    '😈': 'чёрт черт дьявол рожки devil',
    '😴': 'сон сплю спать засыпаю sleep',
    '😭': 'рыдаю плач слёзы слезы cry',
    '🤓': 'ботаник очки умник nerd',
    '👻': 'привидение призрак ghost',
    '👨\u200d💻': 'программист разработчик компьютер developer coder',
    '👀': 'глаза смотрю слежу видел eyes look',
    '🎃': 'тыква хэллоуин halloween pumpkin',
    '🙈': 'обезьяна не вижу стыд monkey',
    '😇': 'ангел нимб святой angel',
    '😨': 'страх испуг боюсь fear',
    '🤝': 'рукопожатие договор сделка согласен handshake deal',
    '✍': 'пишу рука ручка записал write',
    '🤗': 'обнимаю объятия обнимашки hug',
    '🫡': 'честь салют есть принято salute',
    '🎅': 'дед мороз санта santa',
    '🎄': 'ёлка елка новый год christmas tree',
    '☃': 'снеговик зима snowman',
    '💅': 'маникюр ногти лак nails',
    '🤪': 'дурачок безумие сумасшедший crazy zany',
    '🗿': 'истукан статуя моаи moai',
    '🆒': 'круто кул cool',
    '💘': 'сердце стрела амур влюблённость arrow heart',
    '🙉': 'обезьяна не слышу monkey',
    '🦄': 'единорог unicorn',
    '😘': 'воздушный поцелуй чмок целую kiss',
    '💊': 'таблетка лекарство pill',
    '🙊': 'обезьяна молчу не скажу monkey',
    '😎': 'очки крутой солнцезащитные cool sunglasses',
    '👾': 'пришелец монстр игра инопланетянин alien',
    '🤷\u200d♂': 'пожимает плечами не знаю мужчина shrug',
    '🤷': 'пожимаю плечами не знаю без понятия shrug',
    '🤷\u200d♀': 'пожимает плечами не знаю женщина shrug',
    '😡': 'злость гнев ярость бешенство angry rage',
    '😂': 'смех слёзы слезы ржу laughing tears',
}
